import { createContext } from 'react';
import { MenuItemContext } from './types';

export const Context = createContext<MenuItemContext>({
	active: false,
	disabled: false,
	muted: false,
	size: 'medium',
});
